import editDemographics from './editDemographics';
import editDemographicsHOC from './editDemographicsHOC';

export default editDemographicsHOC(editDemographics);



// WEBPACK FOOTER //
// ./src/components/EditDemographics/index.jsx